import apiClient from './apiClient';
import {
  STORES,
  cacheMultiple,
  cacheData,
  getCachedData,
  getAllCachedData,
  setMetadata
} from '../utils/offlineDB';

// Alle Termine abrufen (mit Cache-Fallback)
export const getAllTermine = async (params = {}) => {
  try {
    const response = await apiClient.get('/termine', { params });
    const termine = response.data;

    // Im Hintergrund cachen
    if (Array.isArray(termine) && termine.length > 0) {
      try {
        await cacheMultiple(STORES.CACHE_TERMINE, termine);
        await setMetadata(`${STORES.CACHE_TERMINE}-last-sync`, Date.now());
        console.log(`📦 ${termine.length} Termine gecached`);
      } catch (cacheError) {
        console.warn('Termine caching failed:', cacheError);
      }
    }

    return termine;
  } catch (error) {
    // Bei Netzwerkfehler: Cache verwenden
    if (!navigator.onLine || error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
      console.log('📴 Offline: Lade Termine aus Cache');
      const cachedTermine = await getAllCachedData(STORES.CACHE_TERMINE);
      if (cachedTermine.length > 0) {
        return cachedTermine;
      }
    }
    throw error;
  }
};

// Einzelnen Termin abrufen (mit Cache-Fallback)
export const getTerminById = async (id) => {
  try {
    const response = await apiClient.get(`/termine/${id}`);
    const termin = response.data;

    // Im Hintergrund cachen
    if (termin && termin.id) {
      try {
        await cacheData(STORES.CACHE_TERMINE, termin);
      } catch (cacheError) {
        console.warn('Termin caching failed:', cacheError);
      }
    }

    return termin;
  } catch (error) {
    // Bei Netzwerkfehler: Cache verwenden
    if (!navigator.onLine || error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
      console.log('📴 Offline: Lade Termin aus Cache', id);
      const cachedTermin = await getCachedData(STORES.CACHE_TERMINE, id);
      if (cachedTermin) {
        return cachedTermin;
      }
    }
    throw error;
  }
};

// Neuen Termin erstellen
export const createTermin = async (data) => {
  const response = await apiClient.post('/termine', data);
  return response.data;
};

// Termin aktualisieren
export const updateTermin = async (id, data) => {
  const response = await apiClient.put(`/termine/${id}`, data);
  return response.data;
};

// Termin löschen
export const deleteTermin = async (id) => {
  const response = await apiClient.delete(`/termine/${id}`);
  return response.data;
};
